export const getElementWidthWithoutPadding = (element: Element): number => {
  const styles = window.getComputedStyle(element)
  const paddingLeft = parseInt(styles.paddingLeft, 10)
  const paddingRight = parseInt(styles.paddingRight, 10)
  const widthWithoutPadding = element.clientWidth - paddingLeft - paddingRight
  return widthWithoutPadding
}
